import React,{useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import {Toaster} from 'react-hot-toast';
import {UrlQuery} from "biz9-react-utility";
// -- biz9 --
import {Str,DateTime,Log} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {User_Logic} from "biz9-user";
import {Message,Type,Title,Project_Table} from "../../../../constant";
import {App,Data,Image,Style,Toast_Message,System,User} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
import {Portal_Type,Portal_Table,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Data,Portal_Remote_CMS} from "biz9-portal-app";
const Dashboard_Admin_Cart = () => {
    const timeoutRef = useRef(null);
    const [user,setUser] = useState(User.get());
    const [val_sub_page_title,setValSubPageTitle] = useState(Title.LABEL_CMS_PAGE_TITLE_ADMIN_CARTZ);
    const [val_search,setValSearch] = useState("");
    const [stop_search,setStopSearch] = useState('');
    const [carts,setCarts] = useState([]);
    const [cart_items,setCartItems] = useState([]);
    const [cart_sub_items,setCartSubItems] = useState([]);
    const columns = [
    {
    title: "Cart Number",
       dataIndex: "cart_number",
       key: "cart_number",
    render: (text: string, record: any) => (
            <>
            <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_cart_detail+"?cart_number="+record.cart_number} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.image_filename,Image_Format.SQUARE_THUMB,{table:Portal_Table.CART})} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_cart_detail+"?cart_number="+record.cart_number} className="text-dark">
                   {record.cart_number}
                   </Link>
                   </h2>
            </>
        ),
           sorter: true
    },
 {
        title: "UserName",
        dataIndex: "user_title",
        key: "user_title",
        render: (text: string, record: any) => (
                    <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user.username ?? "not-found"}
                   </Link>
                   </h2>
                  ),
             sorter: true
    },
 {
        title: "Grand Total",
       dataIndex: "grand_total",
       key: "grand_total",
    render: (text: string, record: any) => (
            <>
            {Str.get_money(record.grand_total)}
            </>
        ),
      sorter: true
     },
   {
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
          sorter: true
    },
 {
title: "Action",
       dataIndex: "action",
       render: (res: string, record: any) => (
               <>
               <div className="dropdown dropdown-action">
               <Link to="#" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
               <FeatherIcon icon="more-vertical" />
               </Link>
               <div className="dropdown-menu dropdown-menu-right">
               <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_delete(record.id)} }} >
               <FeatherIcon icon="trash" /> Delete
               </Link>
               </div>
               </div>
               </>
               ),
    },
     ];
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_data();
        if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    },[]);
    async function get_data () {
        const option  = {foreigns:[User_Logic.get_foreign_user()]};
        const search = Data_Logic.get_search(Portal_Table.CART,{},{sort_by:{date_create:-1}});
        const [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        Log.w('11_response',response);
        Log.w('11_data',data);
        bind_items(data);
        Toast_Message.dismiss();
    };
    async function bind_items(data){
        // -- carts --
        setCarts(data.items);

    };
    async function btn_post_delete(id: any) {
        if(window.confirm(Message.CONFIRM)){
            Toast_Message.loading(Message.DELETING);
            let [response,data] = await Portal_Remote_CMS.delete_ids(App.get_url(Portal_Url.CMS_DELETE_IDS),Portal_Table.CART,[id]);
            Toast_Message.success(response.message);
            setCarts(carts.filter(item=>item.id!==id));
        }
    };
    const post_search = (e) => {
        const value = e.target.value.trim();
        setValSearch(value);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
                setStopSearch(value);
                let filter = {$or:[
                {title:{ $regex:".*"+String(value),$options:"i"}}
                ]};
                let search = Data_Logic.get_search(Portal_Table.CART,filter);
                post_search_data(search);
                }, 500);
    };
    async function post_search_data(search) {
        Toast_Message.loading(Message.SEARCHING);
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search);
        setCarts(data.items);
        Toast_Message.dismiss();
    }
  return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="wallet-wrap">
            <div className="wallet-list">
            <div className="wallet-item mt-10">
            <div  className="pt-10">
            <input type='text' autoComplete='off' className='form-control' placeholder={"Search"} value={val_search} onChange={post_search}/>
            </div>
            </div>
            </div>
            <div className="d-flex align-items-center">
            <Link hidden={true} to="#" data-bs-toggle="modal" data-bs-target="#withdraw" className="btn btn-primary">
            {Title.LABEL_ADD}
            </Link>
            </div>
            </div>
            <div className="table-filter pb-4">
            <Table onUpdate={setCarts} allow_multiple={true} table={Portal_Table.CART} dataSource={carts} columns={columns} Selection={false} />
            </div>
            <div className="table-footer">
            <div id="tablepage" />
            </div>
            </div>
            {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
        </>
        );
};
export default Dashboard_Admin_Cart;
